export const getUserTabs = (role, isUnderwriterWorking) => {
  const TABS_BY_ROLE = {
    MANAGER: [
      { label: 'Заявки', code: 'applications' },
      { label: 'Клиенты', code: 'clients' },
      { label: 'Контракты', code: 'contracts' },
      { label: 'Залоги', code: 'collaterals' }
    ],
    UNDERWRITER: [
      { label: 'Главная', code: 'main' },
      { label: 'Заявки', code: 'applications' },
      { label: 'Клиенты', code: 'clients' },
      { label: 'Контракты', code: 'contracts' },
      { label: 'Залоги', code: 'collaterals' },
      { label: 'Мои заявки', code: 'ownApplications'}

    ],
    HEAD_UNDERWRITER: [
      { label: 'Главная', code: 'main' },
      { label: 'Заявки', code: 'applications' },
      { label: 'Клиенты', code: 'clients' },
      { label: 'Контракты', code: 'contracts' },
      { label: 'Залоги', code: 'collaterals' },
      { label: 'Мои заявки', code: 'ownApplications'}
    ],
    SUPER_UNDERWRITER: [
      { label: 'Главная', code: 'main' },
      { label: 'Заявки', code: 'applications' },
      { label: 'Клиенты', code: 'clients' },
      { label: 'Контракты', code: 'contracts' },
      { label: 'Залоги', code: 'collaterals' },
      { label: 'Мои заявки', code: 'ownApplications'}
    ],
    DICT_ADMIN: [
      { label: 'Дилеры',code: 'dealers' },
      { label: 'Группы',code: 'groups' },
      { label: 'Локации',code: 'locations' }
    ]
  }
  return TABS_BY_ROLE[role] || []
}
